import React from 'react';
import { DefaultQuestionProps } from '../default/default';

interface DateQuestionProps extends DefaultQuestionProps {}

export const DateQuestion = ({ answer, answerQuestion }: DateQuestionProps) => {
	const onChange = (event: React.ChangeEvent) => {
		answerQuestion((event.target as HTMLInputElement).value, false);
	};

	return (
		<div>
			<input
				type="date"
				data-testid="date-question"
				value={answer}
				onChange={onChange}
			/>
		</div>
	);
};
